'use client'

import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'
import { Section, SectionHeading } from '@/components/platform/v2/Section'
import { PageCta, PageHero } from '@/components/platform/v2/PageEdge'

const FORMATS = [
    {
        title: 'В команду',
        text: 'Если мы подходим друг другу для постоянной работы.',
    },
    {
        title: 'Проектное сотрудничество',
        text: 'Если есть сильная экспертиза под конкретную задачу.',
    },
    {
        title: 'Как партнёр',
        text: 'Если можем создавать или развивать что-то вместе.',
    },
]

const DIRECTIONS = [
    {
        title: 'Продажи и развитие',
        text: 'Нам интересны люди, которые умеют разбираться в задачах бизнеса, проводить демонстрации и доводить клиента до запуска.',
    },
    {
        title: 'Внедрение и работа с клиентами',
        text: 'Погружение в процессы клиента, настройка контура платформы и обучение команды заказчика.',
    },
    {
        title: 'Frontend-разработка',
        text: 'Интерфейсы платформы и приложений компаний: продуктовые экраны, админки, мобильный опыт.',
    },
    {
        title: 'Backend и интеграции',
        text: 'Сервисы платформы, интеграции с 1С, банками, платежными агрегаторами и внешними каналами.',
    },
    {
        title: 'Поддержка',
        text: 'Поддержка клиентов вместе с AI-помощником: разбор вопросов, эскалация, база знаний.',
    },
    {
        title: 'Маркетинг и контент',
        text: 'Тексты, кейсы, рассылки и материалы для продукта и партнёрской сети.',
    },
]

const VacanciesPageComponent = () => (
    <div className="vcentre-public pt-24 sm:pt-28 md:pt-32">
        <PageHero
            eyebrow="Сотрудничество"
            title="Работать с VCENTRE"
            text={
                <p>Мы постоянно знакомимся со специалистами, предпринимателями и командами, с которыми можем создавать продукты вместе.</p>
            }
            actions={
                <>
                    <a href="mailto:help@vcentre.pro" className="btn-primary">Начать разговор</a>
                    <Link href="/platform/company" className="btn-ghost">
                        О компании
                    </Link>
                </>
            }
            visual={
                <img
                    src={'/assets/images/platform/company-mascot-hero.png'}
                    alt="Маскот VCENTRE.IT приветствует будущих участников команды"
                    loading="eager"
                    className="w-full max-w-[330px] animate-float drop-shadow-[0_30px_60px_rgba(0,0,0,0.6)] sm:max-w-[420px]"
                />
            }
        />

        <Section tone="quiet">
            <SectionHeading
                align="left"
                title="Как можно работать вместе"
                text="Мы открыты к специалистам, командам и людям, которым близко то, что строит VCENTRE."
            />
            <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {FORMATS.map((f) => (
                    <article key={f.title} className="surface flex h-full flex-col">
                        <p className="text-base font-bold text-foreground">{f.title}</p>
                        <p className="body-text mt-3">{f.text}</p>
                        <a
                            href={`mailto:help@vcentre.pro?subject=${encodeURIComponent(`Сотрудничество: ${f.title}`)}`}
                            className="btn-link mt-auto inline-flex items-center gap-1 pt-4"
                        >
                            Рассказать о себе <ArrowUpRight className="h-4 w-4" />
                        </a>
                    </article>
                ))}
            </div>
        </Section>

        <Section>
            <SectionHeading
                align="left"
                title="Где нам особенно интересны люди"
                text="Не штатные вакансии, а направления, в которых мы всегда рады познакомиться с сильными людьми."
            />
            <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {DIRECTIONS.map((d) => (
                    <article key={d.title} className="surface flex h-full flex-col">
                        <p className="text-base font-bold text-foreground">{d.title}</p>
                        <p className="body-text mt-3">{d.text}</p>
                        <a
                            href={`mailto:help@vcentre.pro?subject=${encodeURIComponent(`Сотрудничество: ${d.title}`)}`} className="btn-link mt-auto inline-flex items-center gap-1 pt-4"
                        >
                            Рассказать о себе <ArrowUpRight className="h-4 w-4" />
                        </a>
                    </article>
                ))}
            </div>
        </Section>

        <Section>
            <PageCta
                title="Не нашли своё направление?"
                text={<p>Напишите, чем хотите заниматься — посмотрим, где вы усилите команду.</p>}
                visual={
                    <img
                        src={'/assets/images/platform/company-mascot-cta.png'}
                        alt="Маскот VCENTRE.IT с ноутбуком приглашает рассказать о себе"
                        loading="lazy"
                        className="w-full max-w-[260px] drop-shadow-[0_24px_48px_rgba(0,0,0,0.55)]"
                    />
                }
                actions={
                    <>
                        <a href="mailto:help@vcentre.pro" className="btn-primary">Написать команде</a>
                        <Link href="/platform/contacts" className="btn-ghost">
                            Контакты
                        </Link>
                    </>
                }
            />
        </Section>
    </div>
)

export default VacanciesPageComponent
